import { AText, Box } from '@alf/uikit';
import { useCountdown } from '@namespace/helpers';
import { useI18n } from '@namespace/i18n';

import styles from './index.module.css';

const BonusCountdownTimer = ({ time, title, className }) => {
  const { days, hours, minutes, seconds } = useCountdown(time);
  const { t } = useI18n();

  return (
    <Box padding="xs 0" direction="column" align="center" className={className}>
      <AText
        data-testid="countdown-timer-title"
        breed="R"
        size="s"
        color="po_txt_color_3"
        className={styles.title}
      >
        {title}
      </AText>
      <Box>
        <Box align="center" direction="column" className={styles.dataItem}>
          <AText
            data-testid="countdown-timer-days"
            color="po_txt_color_1"
            breed="B"
            size="2xl"
          >
            {days}
          </AText>
          <AText breed="R" size="xs" color="po_txt_color_3">
            {t('web.personaloffice.bonuses.timer.days')}
          </AText>
        </Box>
        <Box align="center" direction="column" className={styles.dataItem}>
          <AText
            data-testid="countdown-timer-hours"
            color="po_txt_color_1"
            breed="B"
            size="2xl"
          >
            {hours}
          </AText>
          <AText breed="R" size="xs" color="po_txt_color_3">
            {t('web.personaloffice.bonuses.timer.hours')}
          </AText>
        </Box>
        <Box align="center" direction="column" className={styles.dataItem}>
          <AText
            data-testid="countdown-timer-minutes"
            color="po_txt_color_1"
            breed="B"
            size="2xl"
          >
            {minutes}
          </AText>
          <AText breed="R" size="xs" color="po_txt_color_3">
            {t('web.personaloffice.bonuses.timer.minutes')}
          </AText>
        </Box>
        <Box align="center" direction="column" className={styles.dataItem}>
          <AText
            data-testid="countdown-timer-seconds"
            color="po_txt_color_1"
            breed="B"
            size="2xl"
          >
            {seconds}
          </AText>
          <AText breed="R" size="xs" color="po_txt_color_3">
            {t('web.personaloffice.bonuses.timer.seconds')}
          </AText>
        </Box>
      </Box>
    </Box>
  );
};

export default BonusCountdownTimer;
